<template>
  <div id="parkPlaceList">
    <el-row>
      <el-col :span="24"
              class="titleLine">
        <el-breadcrumb separator-class="el-icon-arrow-right"
                       class="titleLine1">
          <el-breadcrumb-item>数据中心</el-breadcrumb-item>
          <el-breadcrumb-item>{{title}}</el-breadcrumb-item>
          <el-breadcrumb-item>场库车位统计</el-breadcrumb-item>
        </el-breadcrumb>
      </el-col>
    </el-row>
    <el-form :inline="true"
             label-width="80px">
      <el-row>
        <el-col :span="24">
          <el-form-item label="客户::">
            <el-select v-model="pageSearch.fCustID"
                       @change="loadPark"
                       clearable
                       filterable
                       placeholder="请选择客户"
                       style="width:200px;">
              <el-option v-for="item in cust_list"
                         :key="item.fCustID"
                         :label="item.unionName"
                         :value="item.fCustID">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="场库::">
            <!-- @change="loadChannel" -->
            <el-select v-model="pageSearch.fParkID"
                       filterable
                       placeholder="请选择场库"
                       style="width:200px;"
                       clearable>
              <el-option v-for="item in park_list"
                         :key="item.fParkID"
                         :label="item.fParkName"
                         :value="item.fParkID">
              </el-option>
            </el-select>
          </el-form-item>
          <!-- <el-form-item label="通道::">
            <el-select v-model="pageSearch.fChnlID"
                       filterable
                       placeholder="请选择通道"
                       style="width:200px;"
                       clearable>
              <el-option v-for="item in channel_list"
                         :key="item.fChnlID"
                         :label="item.fChnlName"
                         :value="item.fChnlID">
              </el-option>
            </el-select>
          </el-form-item> -->
        </el-col>
        <el-col :span="24">
          <el-form-item label="开始时间::">
            <el-date-picker v-model="startTime"
                            style="width:200px"
                            type="datetime"
                            :clearable="false"
                            placeholder="选择开始时间">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="结束时间::">
            <el-date-picker v-model="endTime"
                            style="width:200px"
                            :clearable="false"
                            type="datetime"
                            placeholder="选择结束时间">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="">
            <el-button type="primary"
                       size="small"
                       icon="el-icon-search"
                       @click="page_list">查询</el-button>
            <el-button type="success"
                       size="small"
                       icon="el-icon-share"
                       :loading="export_loading"
                       v-if="is_export"
                       @click="exportData">{{export_msg}}</el-button>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <el-row>
      <el-col :span="24"
              style="height: 5px"></el-col>
    </el-row>
    <el-row>
      <el-col :span="24">
        <el-table :data="pageData"
                  :height="tableHeight"
                  highlight-current-row
                  v-loading="loading"
                  ref="dt"
                  :summary-method="getSummaries"
                  show-summary
                  border
                  stripe
                  style="width: 100%">
          <el-table-column width="50"
                           prop="num"
                           label="序号">
          </el-table-column>
          <el-table-column prop="fCustName"
                           label="客户">
          </el-table-column>
          <el-table-column prop="fParkName"
                           label="场库">
          </el-table-column>
          <el-table-column prop="fParkCount"
                           align="right"
                           label="总车位">
          </el-table-column>
          <el-table-column prop="fInCount"
                           align="right"
                           label="进场车辆">
          </el-table-column>
          <el-table-column prop="fOutCount"
                           align="right"
                           label="离场车辆">
          </el-table-column>
          <el-table-column prop="fPresentCount"
                           align="right"
                           label="在场车辆">
          </el-table-column>
          <el-table-column prop="fResCount"
                           align="right"
                           label="剩余车位">
          </el-table-column>
          <el-table-column prop="fPresentCountRate"
                           align="right"
                           label="车位占比率">
          </el-table-column>
          <!-- <el-table-column label="操作"
                           align="center"
                           fixed="right"
                           width="180">
            <template slot-scope="scope">
              <el-button size="mini"
                         type="success"
                         @click="handleInfo(scope.$index, scope.row)">查看</el-button>
              <el-button size="mini"
                         type="primary"
                         v-if="scope.row.fStatus=='0'"
                         @click="handle(scope.$index, scope.row)">处理</el-button>
            </template>
          </el-table-column> -->
        </el-table>
      </el-col>
    </el-row>
    <!-- <el-row class="pagination">
      <el-col :span="24">
        <div class="block">
          <span class="demonstration"></span>
          <el-pagination @current-change="handleCurrentChange"
                         @size-change="handleSizeChange"
                         :current-page="pageSearch.pageIndex"
                         :page-size="pageSearch.pageSize"
                         :page-sizes="[10, 20, 50, 100]"
                         background
                         layout="total,sizes, prev, pager, next, jumper"
                         :total="pageCount"
                         v-if="pageCount>0">
          </el-pagination>
        </div>
      </el-col>
    </el-row> -->
  </div>
</template>
<script>
import { report as api } from '../../api/report'
import * as park from '../../api/park'
import * as user from '../../api/user'
const delay = (function () {
  let timer = 0
  return function (callback, ms) {
    clearTimeout(timer)
    timer = setTimeout(callback, ms)
  }
})()
export default {
  data () {
    return {
      title: '定制报表',
      dialogTitle: '',
      dialogVisible: false,
      form: {},
      is_export: false,
      tableHeight: 0,
      pageCount: 0,
      loading: false,
      export_loading: false,
      export_msg: '导出',
      pageData: [],
      total: { sumParkCount: '', sumInCount: '', sumOutCount: '', sumPresentCount: '', sumResCount: '', sumPresentCountRate: '' },
      cust_list: [],
      park_list: [],
      channel_list: [],
      startTime: '',
      endTime: '',
      pageSearch: {
        // pageIndex: 1,
        // pageSize: 20,
        fCustID: '',
        fParkID: '',
        // fChnlID: '',
        fStartTime: '',
        fEndTime: '',
        isExport: 1

      }

    }
  },
  methods: {
    // 搜索词搜索
    wordSearch () {
      delay(() => {
        this.page_list()
      }, 1000)
    },
    loadPark (fCustID) {
      this.pageSearch.fParkID = ''
      this.park_list = []
      this.pageSearch.fChnlID = ''
      this.channel_list = []
      // 加载在场数据列表
      // this.page_list()
      if (!fCustID) { return }
      // 加载场库
      park.getParkList({ fCustID: fCustID }).then(res => {
        if (res && res.data) {
          var data = res.data
          if (data.IsOk) {
            this.park_list = data.Data
          } else {
            this.$message.error('提示：加载场库列表失败')
          }
        }
      })
    },
    loadChannel (fParkID) {
      this.pageSearch.fChnlID = ''
      this.channel_list = []
      // 加载在场数据列表
      // this.page_list()
      if (!fParkID) { return }
      // 加载通道
      park.channelList({ fParkID: fParkID, fCustID: this.pageSearch.fCustID }).then(res => {
        if (res && res.data) {
          var data = res.data
          if (data.IsOk) {
            this.channel_list = data.Data
            // console.log(this.channel_list)
            // if (this.channel_list && this.channel_list.length > 0) {
            //   this.pageSearch.fInChnlID = this.channel_list[0].fChnlID
            // }
          } else {
            this.$message.error('提示：加载通道列表失败')
          }
        }
      })
    },
    getSummaries (param) {
      var sums = []
      for (let index = 0; index < 9; index++) {
        if (index === 1) {
          sums[index] = '合计'
        } else if (index === 3) {
          sums[index] = this.total.sumParkCount
        } else if (index === 4) {
          sums[index] = this.total.sumInCount
        } else if (index === 5) {
          sums[index] = this.total.sumOutCount
        } else if (index === 6) {
          sums[index] = this.total.sumPresentCount
        } else if (index === 7) {
          sums[index] = this.total.sumResCount
        } else if (index === 8) {
          sums[index] = this.total.sumPresentCountRate
        } else {
          sums[index] = ''
        }
      }
      return sums
    },
    page_list (index) {
      // if (index && index >= 1) {
      //   this.pageSearch.pageIndex = index
      // } else {
      //   this.pageSearch.pageIndex = 1
      // }
      this.loading = true
      this.pageSearch.fStartTime = this.$dateFormat(this.startTime, 'yyyy-MM-dd hh:mm:ss')
      this.pageSearch.fEndTime = this.$dateFormat(this.endTime, 'yyyy-MM-dd hh:mm:ss')
      this.pageSearch.isExport = 0
      api.getParkPlacesList(this.pageSearch).then(res => {
        this.loading = false
        if (res && res.data) {
          var data = res.data
          if (data.IsOk) {
            this.pageData = data.Data.data || []
            this.total = data.Data.total
            setTimeout(() => { this.$refs['dt'].doLayout() }, 100)
            // this.pageCount = data.Data.count
          } else {
            this.$message.error('提示：场库车位统计失败')
          }
        }
      })
    },
    // indexMethod (index) {
    //   return this.pageSearch.pageSize * (this.pageSearch.pageIndex - 1) + index + 1
    // },
    init () {
      var today = new Date()
      this.startTime = new Date(today.getFullYear(), today.getMonth(), today.getDate(), 0, 0, 0)
      this.endTime = new Date(today.getFullYear(), today.getMonth(), today.getDate(), 23, 59, 59)
      park.getCustByGroup({ fCustTypeID: 0 }).then(res => {
        if (res && res.data) {
          var data = res.data
          if (data.IsOk) {
            this.cust_list = data.Data
            // if (this.cust_list && this.cust_list.length > 0) {
            //   this.pageSearch.fCustID = this.cust_list[0].fCustID
            //   this.loadPark(this.pageSearch.fCustID)
            // }
          } else {
            this.$message.error('提示：加载客户列表失败')
          }
        }
      })
      user.getCurrentUserPers({ perTypeId: 300000 }).then(res => {
        if (res && res.data) {
          var data = res.data
          if (data.IsOk) {
            if (data.Data) {
              this.is_export = data.Data.data.is_export
            }
          } else {
            this.$message.error('提示：加载当前用户权限信息失败')
          }
        }
      })
    },
    exportData () {
      if ((this.pageSearch.fCustID || '').trim().length <= 0) {
        this.$message.error('提示：请先选择客户')
        return false
      }
      this.pageSearch.fStartTime = this.$dateFormat(this.startTime, 'yyyy-MM-dd hh:mm:ss')
      this.pageSearch.fEndTime = this.$dateFormat(this.endTime, 'yyyy-MM-dd hh:mm:ss')
      this.export_loading = true
      this.export_msg = '导出中……'
      var fileName = '所有客户'
      if ((this.pageSearch.fCustID || '').trim().length > 0) {
        var custArr = (this.cust_list || []).filter((item) => {
          return item.fCustID === this.pageSearch.fCustID
        })
        fileName = custArr.length > 0 ? custArr[0].unionName : ''
      }
      this.pageSearch.isExport = 1
      api.getParkPlacesList(this.pageSearch).then(res => {
        this.export_loading = false
        this.export_msg = '导出'
        if (res && res.data) {
          var data = res.data
          if (data.IsOk) {
            if (data.Data) {
              this.fileDownload(data.Data, fileName + '_车位统计.xls')
            }
          } else {
            this.$message.error('提示：' + data.Msg)
          }
        }
      })
    },
    handleSizeChange (val) {
      this.pageSearch.pageSize = val
      this.page_list(this.pageSearch.pageIndex)
    },
    handleCurrentChange (val) {
      this.page_list(val)
    },
    setTableHeight (obj) {
      let clientHeight = obj.getRJPageSize.getRJPageSize()[3] - 220
      obj.tableHeight = clientHeight
    }
  },
  created () {
  },
  mounted () {
    window.onresize = () => {
      this.setTableHeight(this)
    }
    this.init()
  },
  updated () {
    this.setTableHeight(this)
  }
}
</script>
<style>
/* dialog弹出框样式 */
#parkPlaceList .el-dialog {
  min-width: 840px;
}
#parkPlaceList .el-dialog__headerbtn {
  top: 10px;
  font-size: 20px;
}
#parkPlaceList .el-dialog__title {
  color: white;
}
#parkPlaceList .el-dialog__header {
  background-color: #337ab7;
  padding: 10px;
}
#parkPlaceList .el-dialog__body {
  padding: 3px 10px;
  font-size: 13px;
  /* font-family: "宋体"; */
}
#parkPlaceList .fRemark > .el-textarea__inner {
  height: 100px;
}
#parkPlaceList .fRemark_row .el-form-item__content {
  height: 100px;
}
/* 文本框样式 */
#parkPlaceList .el-input__inner {
  height: 32px;
  line-height: 32px;
}
#parkPlaceList .el-input.is-disabled .el-input__inner,
#parkPlaceList .el-textarea.is-disabled .el-textarea__inner {
  color: #606266;
}
#parkPlaceList .break_rule_img .el-form-item__content {
  height: 300px;
}
</style>
<style scoped>
.el-form-item {
  margin-bottom: 5px;
}
.pagination {
  text-align: right;
  padding-top: 5px;
}
.search {
  width: 200px;
}
.danger {
  color: #f56c6c;
}
.success {
  color: #67c23a;
}
</style>



// WEBPACK FOOTER //
// src/view/report/parkPlaceList.vue